import React from "react";
import * as Scrivito from "scrivito";
import { UncontrolledTooltip } from "reactstrap";
import cx from "classnames";
import { Icon } from "components";
import { useTranslate } from "hooks";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";
import { useNodeActions } from "hooks/projectHooks";

export const ProductConfiguratorHeaderSaveUndoButtons = Scrivito.connect(
  ({ isWizardView = false }) => {
    const translate = useTranslate();

    const productId = useProductConfiguratorStore.use.productId();
    const { onSaveConfiguration, setIsProductChanged } =
      useProductConfiguratorStore.use.actions();

    const isProductChanged = useProductConfiguratorStore.use.isProductChanged();

    const nodeActions = useNodeActions();

    const { resetData, getProductRequestData } =
      useProductConfiguratorStore.use.actions();

    const updateExistingProduct = () => {
      if (!isProductChanged) {
        return;
      }

      const productRequestData = getProductRequestData();

      nodeActions.updateProductNodeConfiguration(
        productId,
        productRequestData,
        (_node) => onSaveConfiguration(),
      );

      setIsProductChanged(false);
    };

    return (
      <div className="d-flex gap-2">
        {productId && !isWizardView && (
          <>
            <Icon
              prefix="trox"
              iconName="check-regular"
              onClick={updateExistingProduct}
              id="product-configurator-check-regular-icon"
              className={cx("icon-20 text-gray-700 cursor-pointer", {
                "cursor-not-allowed opacity-20 pe-none": !isProductChanged,
              })}
            />
            <UncontrolledTooltip
              placement="top"
              target="product-configurator-check-regular-icon"
            >
              {translate("PRODUCT_CONFIGURATOR_APPLY_SETTING_BUTTON_TOOLTIP")}
            </UncontrolledTooltip>
          </>
        )}
        <>
          <Icon
            prefix="trox"
            iconName="arrow-rotate-left-regular"
            onClick={resetData}
            id="product-configurator-rotate-left-icon"
            className={cx("icon-20 text-gray-700 cursor-pointer", {
              "cursor-not-allowed opacity-20 pe-none": !isProductChanged,
            })}
          />
          <UncontrolledTooltip
            placement="top"
            target="product-configurator-rotate-left-icon"
          >
            {translate("PRODUCT_CONFIGURATOR_RESET_BUTTON_TOOLTIP")}
          </UncontrolledTooltip>
        </>
      </div>
    );
  },
);
